var map = {
	"./001.jpg": 1383,
	"./002.jpg": 1384,
	"./003.jpg": 1385,
	"./004.jpg": 1386,
	"./005.jpg": 1387,
	"./006.jpg": 1388,
	"./007.jpg": 1389,
	"./008.jpg": 1390,
	"./009.jpg": 1391,
	"./010.jpg": 1392,
	"./011.jpg": 1393,
	"./012.jpg": 1394,
	"./013.jpg": 1395,
	"./014.jpg": 1396,
	"./015.jpg": 1397,
	"./016.jpg": 1398,
	"./017.jpg": 1399,
	"./018.jpg": 1400,
	"./019.jpg": 1401,
	"./020.jpg": 1402,
	"./021.jpg": 1403,
	"./Cotton_NORMAL_MAP.jpg": 1404,
	"./Thumb/001.jpg": 1117,
	"./Thumb/002.jpg": 1118,
	"./Thumb/003.jpg": 1119,
	"./Thumb/004.jpg": 1120,
	"./Thumb/005.jpg": 1121,
	"./Thumb/006.jpg": 1122,
	"./Thumb/007.jpg": 1123,
	"./Thumb/008.jpg": 1124,
	"./Thumb/009.jpg": 1125,
	"./Thumb/010.jpg": 1126,
	"./Thumb/011.jpg": 1127,
	"./Thumb/012.jpg": 1128,
	"./Thumb/013.jpg": 1129,
	"./Thumb/014.jpg": 1130,
	"./Thumb/015.jpg": 1131,
	"./Thumb/016.jpg": 1132,
	"./Thumb/017.jpg": 1133,
	"./Thumb/018.jpg": 1134,
	"./Thumb/019.jpg": 1135,
	"./Thumb/020.jpg": 1136,
	"./Thumb/021.jpg": 1137,
	"./polyester.jpg": 1138
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2007;